import { connect } from 'react-redux';
import View from './CloseButtonView';
import { setOpen } from '../WhatIfsActions';

const mapDispatchToProps = dispatch => ({
  onClose: clientId => () => {
    dispatch(setOpen(clientId, false));
  },
});

export default connect(null, mapDispatchToProps)(View);
